import { BdArrayUtil } from '@bindoc-projects/util-domain-lib';
import type {
  FilterConditionPluginSpecification,
} from '../filter.plugin';
import {
  FilterConditionPluginImpl
} from '../filter.plugin';
import type {
  BdCondition,
} from '@bindoc-projects/condition-domain-lib';
import {
  BdContentCondition,
} from '@bindoc-projects/condition-domain-lib';
import type { ChargeRealm } from '@bindoc-projects/virtual-clinic-domain-lib';

export const AYS_CHARGE_REALM_CONDITION_ID = 'chargeRealm';
export const FilterConditionChargeRealmPluginType: FilterConditionPluginSpecification<
  ChargeRealm[],
  FilterConditionChargeRealmDto,
  AysChargeRealmCondition
> = {
  type: 'chargeRealm',
  category: 'case',
  displayName: { de: 'Entgeltbereich' },
  sortingIndex: 8,
  occurrence: 'multiple',
  fromObject(
    obj: FilterConditionChargeRealmDto,
  ): FilterConditionPluginImpl<ChargeRealm[]> {
    return new FilterConditionChargeRealmPlugin(obj.includes ?? []);
  },
  fromCondition(
    jsonObj: AysChargeRealmCondition,
  ): FilterConditionPluginImpl<ChargeRealm[]> {
    return new FilterConditionChargeRealmPlugin(jsonObj.includes ?? []);
  },
  newInstance(): FilterConditionPluginImpl<ChargeRealm[]> {
    return new FilterConditionChargeRealmPlugin([]);
  },
};

export class FilterConditionChargeRealmPlugin extends FilterConditionPluginImpl<
  ChargeRealm[],
  FilterConditionChargeRealmDto
> {
  public static override Specification: FilterConditionPluginSpecification<
    ChargeRealm[],
    FilterConditionChargeRealmDto,
    AysChargeRealmCondition
  > = FilterConditionChargeRealmPluginType;

  constructor(private includes: ChargeRealm[]) {
    super(FilterConditionChargeRealmPluginType.type);
  }

  clone(): FilterConditionChargeRealmPlugin {
    return new FilterConditionChargeRealmPlugin([...this.includes]);
  }

  override equals(other: FilterConditionChargeRealmPlugin): boolean {
    return (
      super.equals(other) && BdArrayUtil.equals(this.includes, other.includes)
    );
  }

  override validationToText(): string {
    if (this.includes.length === 0) {
      return 'Mindestens einen Entgeltbereich auswählen';
    } else {
      return '';
    }
  }

  toCondition(): BdCondition | null {
    return new AysChargeRealmCondition(this.includes, []);
  }

  toJSON(): FilterConditionChargeRealmDto | null {
    return {
      type: this.type,
      includes: this.includes,
    };
  }

  toText(): string | null {
    if (this.includes.length === 1) {
      return 'ein Entgeltbereich';
    } else {
      return `${this.includes.length} Entgeltbereiche`;
    }
  }

  toValue(): ChargeRealm[] {
    return this.includes;
  }
}

export class AysChargeRealmCondition extends BdContentCondition<ChargeRealm> {
  constructor(includes: ChargeRealm[], excludes: ChargeRealm[]) {
    super(AYS_CHARGE_REALM_CONDITION_ID, includes, excludes);
  }
}

interface FilterConditionChargeRealmDto {
  type: string;
  includes: ChargeRealm[];
}
